import { createFileRoute, Link } from "@tanstack/react-router";
import { SITE_URL } from "@/lib/utils";

export const Route = createFileRoute("/privacy")({
  head: () => ({
    meta: [
      { title: "Privacy Policy — Pluggz" },
      { name: "description", content: "How Pluggz collects, uses, and protects your personal data under GDPR." },
    ],
    links: [{ rel: "canonical", href: `${SITE_URL}/privacy` }],
  }),
  component: PrivacyPage,
});

function PrivacyPage() {
  return (
    <article className="mx-auto max-w-3xl px-6 py-16 prose prose-neutral">
      <h1 className="font-serif text-4xl">Privacy Policy</h1>
      <p className="text-sm text-muted-foreground">Last updated: 2026-01-15</p>

      <h2>1. Who we are</h2>
      <p>Pluggz is an affiliate marketplace connecting creators with brands. We are operated by CEO Live Ltd, the data controller for personal data processed via this site.</p>

      <h2>2. Data we collect</h2>
      <ul>
        <li><strong>Account data:</strong> email, display name, avatar.</li>
        <li><strong>Creator data:</strong> handle, bio, socials, payout details.</li>
        <li><strong>Usage data:</strong> affiliate clicks, referrers, hashed IP, user agent.</li>
        <li><strong>Cookies:</strong> essential cookies for auth; optional analytics cookies (see banner).</li>
      </ul>

      <h2>3. Legal basis (GDPR Art. 6)</h2>
      <p>Contract performance (account & payouts), legitimate interest (fraud prevention, click attribution), and consent (optional analytics cookies).</p>

      <h2>4. Your rights</h2>
      <p>Under GDPR you can access, correct, export, restrict, or delete your data. Visit <Link to="/privacy-settings" className="underline">Privacy Settings</Link> to exercise these rights, or email <a href="mailto:privacy@pluggzofficial.com">privacy@pluggzofficial.com</a>.</p>

      <h2>5. Retention</h2>
      <p>Account data is retained while your account is active. Commission records may be kept for up to 7 years for tax compliance.</p>

      <h2>6. International transfers</h2>
      <p>We use EU-hosted infrastructure where possible. Sub-processors outside the EEA rely on Standard Contractual Clauses.</p>

      <h2>7. Contact</h2>
      <p>Data Protection Officer: <a href="mailto:dpo@pluggzofficial.com">dpo@pluggzofficial.com</a></p>
    </article>
  );
}
